import { render, staticRenderFns } from "./setaccount.vue?vue&type=template&id=4ff9b83e&scoped=true&"
import script from "./setaccount.vue?vue&type=script&lang=js&"
export * from "./setaccount.vue?vue&type=script&lang=js&"
import style0 from "./setaccount.vue?vue&type=style&index=0&id=4ff9b83e&lang=less&scoped=true&"
import style1 from "./setaccount.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff9b83e",
  null
  
)

export default component.exports